<!--
 * @Author: your name
 * @Date: 2022-06-21 09
-->
<template>
  <div class="latest-activety">
    <div class="dynamic_banner"><img src="~@/assets/icon/home/dynamic_banner.jpg" alt=""></div>
    <second-title 
      letter="V"
      enTitle="oge Events"
      current_add="无极动态"
      add_one="首页"
      add_tow="新闻潮汛"
      add_three="最新活动"
    >
    </second-title>
    <!-- 内容 -->
    <div class="dynamic_row">
      <div class="dynamic_content">
        <div class="dynamic_list" v-for="(item,index) in dynamicList" :key="index" @click="toDetails(item)">
          <div class="dynamic_img animate__animated animate__zoomIn" ><img :src="item.preview" alt=""></div>
          <div class="dynamic_text animate__animated animate__zoomIn">{{item.title}}</div>
          <div class="dynamic_time animate__animated animate__zoomIn">
            <van-icon class="time-icon" name="clock-o" />
            <div class="time_detals">{{item.create_time}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看更多 -->
    <div class="view_more" @click="moreClick" v-if="!moreLoading">
      <div>查看更多</div>
      <van-icon name="arrow-down" class="ckgd" />
    </div>
    <div class="view_more" @click="moreClick" v-else>
      <div>加载中...</div>
    </div>
    <base-footers></base-footers>
  </div>
</template>
<script>
import { newsListApi } from "@/api/api";
import SecondTitle from '@/components/SecondTitle';
import Footers from "@/components/Footers.vue";
import { Icon } from 'vant';
export default {
  components:{
    SecondTitle,
    BaseFooters:Footers,
    [Icon.name]: Icon,
  },
  data(){
    return{
      page:1,
      page_size:10,
      moreLoading:false,
      dynamicList:[]
    }
  },
  created(){
    this.newsListApi()
  },
  methods:{
    newsListApi(){
      const params = {
        m:'Mobile',
        c:'Article',
        a:'get_all_news_list',
        store_id:21,
        lang:1,
        type:5,
        page:this.page,
        page_size:this.page_size
      }
      newsListApi(params).then(({data})=>{
        this.moreLoading = false
        if (this.page == 1) {
          this.dynamicList = data.datas.info
          if (this.page*this.page_size > data.datas.count) {
              this.moreShow = false
          }
        }else{
          data.datas.info.forEach((item,idx) => {
            if (this.page*this.page_size <= data.datas.count) {
              this.dynamicList.push(item)
            }
            if (this.page*this.page_size > data.datas.count) {
              this.dynamicList.push(item)
              this.moreShow = false
            }
          });
        }
      })
    },
    toDetails(item){
      this.$router.push('/dynamicDetail?id='+ item.articel_id)
      localStorage.setItem("content",item.content)
    },
    // 查看更多
    moreClick(){
      this.page++
      this.newsListApi()
      this.moreLoading = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>